export const DEFAULT_TITLE = 'Default Title'
export const TOGGLE_EVENT_NAME = 'toggle'
export const TEST_ID = 'base-folding-block'
export const CONTENT_TEST_ID = 'base-folding-block-content'
export const SUMMARY_TEST_ID = 'base-folding-block-summary'
